<template>
  <el-dialog
    class="number-of-treatment-wrapper"
    title="参数编号"
    :visible.sync="isShowContont"
    :close-on-click-modal="false"
    width="30%"
    :append-to-body="true"
      :modal-append-to-body="false"
  >
    <div class="content" >
      <el-form :model="ruleForm" status-icon :rules="rules" ref="addParNumForm" label-width="80px"
               class="demo-ruleForm" @submit.native.prevent="">
        <el-form-item label="参数编号" prop="detail_title">
          <el-input
            ref="addDetailTitle"
            type="text"
            v-focus
            v-model="ruleForm.detail_title"
            @keydown.native.enter="confirm"
            @input="ruleForm.detail_title = ruleForm.detail_title.replace(/[^\d]/g, '')"
            maxlength="2"
            placeholder="编号范围1到99"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" style="padding-right: 10px">
    <!--  <el-button @click="diagnosisFormData.isShowNumberOfTreatmentDialog = false">取 消</el-button>-->
      <el-button type="primary" @click.prevent="confirm" class="foot-save-btn">保 存</el-button>
    </span>
  </el-dialog>
</template>


<script>
  import gql from 'graphql-tag';
  export default {
    
    inject: {
      addParNumData: ['addParNumData'],
      commonData: ['commonData'],
      createEmptyParNum: ['createEmptyParNum'],
    },
    
    props: {
      parNumsList: {
        default: () => {
          return [];
        },
      }
    },
    
    data() {
      const checkDetailTitle = async (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入参数编号'));
        } else if (value === '0') {
          callback(new Error('编号范围1到99'));
        } else {
          const a = await this.checkDetailTitleRepetition(value);
          const b = this.checkDetailTitleRepetitionForLocal(value);
          if (a && b) {
            callback();
          } else {
            callback(new Error('该参数编号已存在'));
          }
        }
      };
      
      return {
          isShowContont:false,
        ruleForm: {
          detail_title: '',
        },
        rules: {
          detail_title: [{ validator: checkDetailTitle, trigger: 'change' }],
        },
      };
    },
    
    watch: {
      'addParNumData.isShowDialog'(val) {
        if (val) {
          this.$nextTick(async() => {
            this.$root.$emit('refresh-par-num-list');
            let parsArrayItem = [];

              try{
                  const res = await this.$apollo.query({
                      query: gql`query(
              $patient_id: Int!
              $treat_no: String!
            ){
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ){
                id
                treat_details{
                  id
                  item_id
                  device_id
                  module_id
                  param_value
                  detail_title
                }
              }
            }`,
                      fetchPolicy: "no-cache",
                      variables: {
                          patient_id: this.commonData.patientId,
                          treat_no: this.commonData.treat_no,
                      },
                  });
                  const parNumsArr = res.data.getCosmetologyReleInfo.treat_details;

                  if (parNumsArr.length) {
                      for (const item of parNumsArr) {
                          item.number = item.detail_title;
                          item.isActive = false;
                      }
                      parNumsArr[0].isActive = true;
                      parsArrayItem = parNumsArr;
                  }
              }catch (e) {
                  this.$message.error(error.message.split(":")[1]);
              }
            
           // this.$refs.addDetailTitle.focus();
              for(let i =1;i<=99;i++){
                  let nextNumString = i.toString();
                  //console.log(parsArrayItem);
                  //console.log(i);
                  const findIndex = parsArrayItem.findIndex((item) => item.number === nextNumString);
                  if (findIndex === -1){
                      this.ruleForm.detail_title = nextNumString;
                      break;
                  }
              }
              this.confirm()
          });
        }
      },
    },
    mounted(){


        /* this.confirm();*/
       /* */
    },
    methods: {
     async confirm() {
       //console.log(this.ruleForm.detail_title)
        /*this.$refs.addParNumForm.validate((valid) => {
          if (valid) {*/
            // 操作
         if (!this.parNumsList.length < 99){
             let isCanAdd = await this.checkDetailTitleRepetition(this.ruleForm.detail_title);
             if (isCanAdd){
                 this.addParNumData.detail_title = this.ruleForm.detail_title;
                 this.addParNumData.isShowDialog = false;

                 //console.log(this.ruleForm.detail_title)

                 this.createEmptyParNum(this.ruleForm.detail_title);
                 this.$message({
                     type: 'success',
                     message: '添加成功!'
                 });
                 // this.$refs.addParNumForm.resetFields();
             }
         } else {
             this.$message.error("参数编号已达上限");
         }

        /*  } else {
            return false;
          }
        });*/
      },
      async checkDetailTitleRepetition(val) {
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $treat_no: String!
              $detail_title: String!
            ){
              checkDetailTitle(
                patient_id: $patient_id
                treat_no: $treat_no
                detail_title: $detail_title
              )
            }`,
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
              detail_title: val,
            },
          });
          return res.data.checkDetailTitle;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      checkDetailTitleRepetitionForLocal(val) {
        const findIndex = this.parNumsList.findIndex((item) => item.number === val);
        return findIndex === -1;
      },
    }
    
  }
</script>

<style lang="less" scoped>
  .number-of-treatment-wrapper{
    .content{
      margin-top: 16px;
      padding-right: 15px;
    }
  }

</style>
